<template>
  <div class="card mt-4">
    <div class="table-responsive">
      <div class="table-controls m-3 d-flex">
        <div class="controls-wrap d-flex align-items-center contact-filters-two">
          <!-- Integration Field -->
          <Search class="mr-3" placeholderText="Search (name)" @search="doSearch" />

          <div class="ml-auto mr-3">
            <v-select
              style="min-width: 320px"
              v-model="selectedCountry"
              @input="handleSearchFilters"
              :options="getAllCountries"
              placeholder="All Countries"
              inputId="employer-select"
              label="name"
              :reduce="country => country.name"
              :clearable="true"
              ><!-- <template #option="{ name, city }"> {{ name }} - {{ city }} </template> --></v-select
            >
          </div>
          <div class="mr-3">
            <v-select
              class="employer-dropdown"
              style="min-width: 320px"
              v-model="selectedEmployers"
              @input="handleSearchFilters"
              :options="employersDropdown"
              placeholder="All Employers"
              inputId="employer-select"
              label="name"
              multiple
              :reduce="employer => employer.id"
              :clearable="true"
              ><!-- <template #option="{ name, city }"> {{ name }} - {{ city }} </template> --></v-select
            >
          </div>

          <div class="mr-3">
            <select
              @change="handleSearchFilters"
              v-model="contactFilter"
              class="form-control"
              style="width: 320px;"
            >
              <option :value="null">All number of contacts</option>
              <option value="no_approved_contacts">No approved contacts</option>
              <option value="no_added_contacts">No added contacts</option>
            </select>
          </div>
          <div
            v-show="!isPreviouslySubmited"
            class="published"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Include previously checked jobs"
            @click="
              isPreviouslySubmited = !isPreviouslySubmited;
              handleSearchFilters($event);
            "
          >
            <span class="fa-stack">
              <i class="fas fa-briefcase" :class="isPreviouslySubmited ? 'is-clicked' : ''"></i>
            </span>
          </div>

          <div
            class="published"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Exclude previously checked jobs"
            @click="
              isPreviouslySubmited = !isPreviouslySubmited;
              handleSearchFilters($event);
            "
            v-show="isPreviouslySubmited"
          >
            <span class="fa-stack">
              <i class="fas fa-briefcase" :class="isPreviouslySubmited ? 'is-clicked' : ''"></i>
            </span>
          </div>
        </div>
      </div>

      <table class="table table-striped custom-table desktop-only-table">
        <thead class="bg-dark">
          <tr>
            <th nowrap scope="col">Title</th>
            <th nowrap scope="col">Employer</th>
            <th nowrap scope="col">Location</th>
            <th nowrap scope="col"></th>
            <th nowrap scope="col">Contacts</th>
            <th nowrap scope="col">Created</th>
            <th nowrap scope="col">Checked</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="job in employers" :key="job.mm_job_id">
            <td>
              <router-link
                :to="{
                  name: 'job_marketing_id',
                  params: { job_id: job.mm_job_id },
                }"
                >{{ job.job_title }}</router-link
              >
            </td>
            <td id="title" nowrap>
              <router-link
                :to="{
                  name: 'employer_marketing_id',
                  params: { employer_id: job.mm_employer_id },
                }"
                >{{ job.mm_employer_name }}</router-link
              >
            </td>
            <td>
              {{ job.city ? `${job.city}, ` : '' }}
              {{ job.country ? job.country : '' }}
            </td>
            <td>
              <div class="icons">
                <popper
                  trigger="hover"
                  :options="{
                    placement: 'top',
                    modifiers: { offset: { offset: '0,10px' } },
                  }"
                >
                  <div class="popper">
                    {{ job.url ? 'Job URL' : 'N/A' }}
                  </div>
                  <div slot="reference">
                    <a :href="job.url" rel="nofollow" target="_blank"
                      ><svgHelper :name="job.url ? 'relocate' : 'relocateFalse'"></svgHelper
                    ></a>
                  </div>
                </popper>

                <popper
                  trigger="hover"
                  :options="{
                    placement: 'top',
                    modifiers: { offset: { offset: '0,10px' } },
                  }"
                >
                  <div class="popper">
                    {{ getWorkPlacePopper(job.workplace) }}
                  </div>
                  <div slot="reference">
                    <div v-html="getWorkPlace(job.workplace)" />
                  </div>
                </popper>

                <popper
                  trigger="hover"
                  :options="{
                    placement: 'top',
                    modifiers: { offset: { offset: '0,10px' } },
                  }"
                >
                  <div class="popper">
                    {{ job.full_time ? `Full-time` : `Part-time` }}
                  </div>
                  <div slot="reference">
                    <div
                      style="width: 25px; height: 25px;"
                      :style="job.full_time ? `fill:#000` : `fill:#999`"
                      v-html="fulltimeSvg"
                    />
                  </div>
                </popper>
              </div>
            </td>
            <td>
              {{ job.mm_employer_approved_contacts_count }} / {{ job.mm_employer_contacts_count }} /
              {{ job.hiring_team_count }}
            </td>

            <td>
              {{
                job.created_at
                  | formatDate({
                    format: getUserProfile.format_date,
                    timezone: getUserProfile.timezone,
                    hasHourAndMinutes: false,
                  })
              }}
            </td>
            <td style="cursor: pointer;">
              <popper
                trigger="hover"
                :options="{
                  placement: 'top',
                  modifiers: { offset: { offset: '0,10px' } },
                }"
              >
                <div class="popper">
                  {{ !job.checked_by ? 'Check job' : 'Uncheck job' }}
                </div>
                <div slot="reference">
                  <i
                    :id="`job-${job.mm_job_id}`"
                    @click="setJobForCheck(job.mm_job_id, !job.checked_by ? true : false)"
                    type="button"
                    data-toggle="modal"
                    href="#addUserModalUserManagment"
                    style="font-size: 18px; color: #999;"
                    class="fas fa-check"
                    :class="job.checked_by ? 'checked' : ''"
                  ></i>
                </div>
              </popper>
            </td>
          </tr>
        </tbody>
      </table>
      <ErrorList v-show="employers.length === 0" class="no-data-message" name="noReviewJobs" />
    </div>

    <Spinner :isLoading="isLoading" />

    <div class="d-flex ml-auto mt-auto bottom-controls">
      <div class="d-none d-sm-block" id="pagination">
        <!-- Pagination -->

        <Pagination
          :currentPage="currentPage"
          :totalPages="totalPages"
          @nextPage="nextPage"
          @prevPage="previousPage"
          @selectPageByNumber="setPageByNumber"
          @firstPage="setToFirstPage"
          @lastPage="setToLastPage"
          @keyup="keymonitor"
        />
      </div>
    </div>
    <div
      class="modal fade add-user-modal"
      id="addUserModalUserManagment"
      tabindex="-1"
      aria-labelledby="addUserModalUserManagment"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addUserModalUserManagment">
              {{ check.status != true ? 'Uncheck Job' : 'Check Job' }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeUser"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 20px">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <p>
                  {{
                    check.status != true
                      ? 'Please confirm that you want to mark the Job as unchecked.'
                      : 'Please confirm that you want to mark the Job as checked.'
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button
              @click="checkJob(check.jobId, check.status)"
              type="button"
              class="btn btn-primary"
            >
              Confirm
            </button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { displayResultsBasedOnScreenHeightMixin } from '../../../mixins/displayResultsBasedOnScreenHeightMixin';
import { mapActions, mapGetters } from 'vuex';
import Pagination from '@/components/Navigations/Pagination';

import Search from '../../common/Search/Search';
import { employmentMixin } from '../../../mixins/employmentMixin';
import { serviceLevelMixin } from '../../../mixins/serviceLevelMixin';
import { jobStatusMixin } from '../../../mixins/jobStatusMixin';
import { stagesMixin } from '../../../mixins/stagesMixin';
import { statusMixin } from '../../../mixins/statusMixin';
import titleMixin from '../../../mixins/titleMixin';
import ErrorList from '@/components/common/errorsList';
import axios from 'axios';

export default {
  components: {
    Pagination,
    Search,
    ErrorList,
  },
  mixins: [
    titleMixin,
    displayResultsBasedOnScreenHeightMixin,
    employmentMixin,
    serviceLevelMixin,
    jobStatusMixin,
    statusMixin,
    stagesMixin,
  ],
  title() {
    return 'Jobs Marketing | Jobshark';
  },
  data: () => ({
    check: {
      status: true,
      jobId: '',
    },
    searchText: '',
    pageCount: 10,
    currentPage: 1,
    totalPages: 1,
    contactFilter: null,
    employers: [],
    employersDropdown: [],
    selectedEmployers: [],
    selectedCountry: '',
    isLoading: false,
    isPreviouslySubmited: false,
    hybridSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 22" fill="none">
  <path d="M21.8418 20.2776H20.0237C19.8355 20.2776 19.6828 20.1198 19.6828 19.9255V16.8744C19.6828 16.8096 19.6318 16.7571 19.5691 16.7571H17.5236C17.4609 16.7571 17.41 16.8096 17.41 16.8744V19.9255C17.41 20.1198 17.2573 20.2776 17.0691 20.2776H15.2509C14.8123 20.2776 14.4554 19.9091 14.4554 19.4561V15.1142H13.66C13.3468 15.1142 13.0918 14.8508 13.0918 14.5274C13.0918 14.3721 13.1532 14.2199 13.26 14.1097L18.3105 9.10964C18.4423 8.97908 18.6505 8.97908 18.7823 9.10964L23.8278 14.104C23.9395 14.2199 24.0009 14.3721 24.0009 14.5274C24.0009 14.8508 23.746 15.1142 23.4328 15.1142H22.6373V19.4561C22.6373 19.9091 22.2804 20.2776 21.8418 20.2776ZM20.3646 19.5735H21.8418C21.9037 19.5735 21.9554 19.5199 21.9554 19.4561V14.7621C21.9554 14.5678 22.1082 14.4101 22.2963 14.4101H23.1514L18.5463 9.85172L13.9414 14.4101H14.7963C14.9845 14.4101 15.1373 14.5678 15.1373 14.7621V19.4561C15.1373 19.5199 15.1891 19.5735 15.2509 19.5735H16.7282V16.8744C16.7282 16.4214 17.085 16.053 17.5236 16.053H19.5691C20.0078 16.053 20.3646 16.4214 20.3646 16.8744V19.5735Z" fill="#161616"></path>
  <path d="M3.62774 12.8074H5.38315V10.4924C5.38315 10.296 5.52982 10.1367 5.71063 10.1367H7.38043C7.56125 10.1367 7.70775 10.296 7.70775 10.4924V12.8074H9.46317V3.45436V0.711599H3.62774V3.45436V12.8074ZM4.32424 7.34242H5.33248V8.43812H4.32424V7.34242ZM7.75843 7.34242H8.76667V8.43812H7.75843V7.34242ZM6.04141 7.34242H7.04965V8.43812H6.04141V7.34242ZM4.32424 4.70603H5.33248V5.80173H4.32424V4.70603ZM7.75843 4.70603H8.76667V5.80173H7.75843V4.70603ZM6.04141 4.70603H7.04965V5.80173H6.04141V4.70603ZM4.32424 2.06947H5.33248V3.16517H4.32424V2.06947ZM7.75843 2.06947H8.76667V3.16517H7.75843V2.06947ZM6.04141 2.06947H7.04965V3.16517H6.04141V2.06947ZM0.322914 13.519C-0.107638 13.519 -0.107638 12.8074 0.322914 12.8074H0.578318V4.46643C0.578318 4.305 0.677301 4.16869 0.812792 4.12509L2.97295 3.2122V0.355885C2.97295 0.159387 3.11945 0 3.30027 0H9.79064C9.97146 0 10.118 0.159387 10.118 0.355885V3.2122L12.2781 4.12509C12.4136 4.16869 12.5126 4.305 12.5126 4.46643V12.8074H12.768C13.1985 12.8074 13.1985 13.519 12.768 13.519C8.61969 13.519 4.47122 13.519 0.322914 13.519ZM6.03795 12.8074H7.05296V10.8483H6.03795V12.8074ZM11.8578 4.70842L10.118 3.97322V12.8074H11.8578V4.70842ZM2.97295 3.97322L1.23311 4.70842V12.8074H2.97295V3.97322Z" fill="#161616"></path>
  <path d="M12.2268 19.4603L12.2281 19.4602L12.2263 19.4715C12.2101 19.5761 12.1514 19.6596 12.0907 19.7312C12.0715 19.754 12.0507 19.777 12.0307 19.7991C12.0197 19.8112 12.009 19.8231 11.9989 19.8346C11.9693 19.868 11.9429 19.8999 11.9218 19.9323L11.9221 19.9325L11.9186 19.9368C11.8343 20.0394 11.7506 20.1431 11.6668 20.2469C11.5025 20.4504 11.3376 20.6545 11.1669 20.8535L11.1671 20.8537L11.1634 20.8572C11.1031 20.9145 11.032 20.9319 10.9647 20.9203C10.8993 20.909 10.8407 20.8709 10.7987 20.8223C10.7568 20.7739 10.7278 20.7107 10.7275 20.6451C10.7272 20.5793 10.7561 20.5154 10.8201 20.4683L11.4173 19.7346C8.2874 19.7153 5.17776 18.6505 2.79782 16.7235C2.1823 16.2444 1.62035 15.7042 1.11176 15.1228L1.11168 15.1229L1.10971 15.1203C1.06277 15.0591 1.05493 14.9909 1.0741 14.9294C1.09265 14.8698 1.13543 14.819 1.18614 14.7839C1.23692 14.7487 1.29994 14.7263 1.36317 14.7285C1.42735 14.7307 1.49006 14.7586 1.53509 14.8199C3.50998 17.0715 6.35008 18.6152 9.40241 19.0683L9.40257 19.0683C10.0714 19.1699 10.7489 19.2217 11.4273 19.2274C11.3576 19.1414 11.2856 19.0556 11.2132 18.9694C11.0568 18.783 10.8988 18.5948 10.7599 18.3981L10.7583 18.3992L10.7536 18.386C10.7044 18.2476 10.8022 18.1323 10.9075 18.0851C10.9619 18.0606 11.0251 18.0502 11.0849 18.0628C11.1446 18.0754 11.1989 18.1109 11.2335 18.1734C11.3541 18.3209 11.4756 18.4681 11.5971 18.6154C11.7952 18.8555 11.9935 19.0958 12.1886 19.338L12.1889 19.3378L12.1922 19.3432C12.2156 19.3812 12.2242 19.4229 12.2268 19.4603Z" fill="#161616" stroke="#161616" stroke-width="0.1"></path>
  <path d="M12.5441 1.45064L12.5427 1.45043L12.5472 1.43912C12.5865 1.33987 12.6657 1.27083 12.7439 1.21404C12.7688 1.19591 12.7953 1.17792 12.8209 1.16058C12.8349 1.15104 12.8487 1.1417 12.8617 1.13264C12.8997 1.10627 12.9342 1.08071 12.9631 1.05344L12.9629 1.05322L12.9674 1.04988C13.0772 0.967504 13.1866 0.884091 13.2961 0.800541C13.511 0.636762 13.7264 0.472464 13.9469 0.314431L13.9468 0.314223L13.9511 0.311714C14.0251 0.269306 14.1011 0.267755 14.167 0.292784C14.2315 0.317276 14.2843 0.366296 14.3179 0.422847C14.3515 0.479179 14.3688 0.547746 14.3549 0.612955C14.341 0.678789 14.2966 0.734694 14.2208 0.766518L13.4427 1.35509C16.7078 2.04254 19.7309 3.74761 21.8092 6.13994C22.3507 6.73974 22.8234 7.38792 23.2316 8.06493L23.2317 8.06488L23.2332 8.06784C23.2696 8.13827 23.2634 8.20768 23.2299 8.26444C23.1977 8.31893 23.1424 8.35911 23.0829 8.38226C23.0231 8.40551 22.9539 8.41367 22.8899 8.39838C22.8254 8.38295 22.7663 8.34336 22.7322 8.27366C21.1458 5.65051 18.505 3.53373 15.4104 2.43786L15.4103 2.43781C14.7315 2.19502 14.033 1.99922 13.3237 1.84839C13.379 1.94868 13.4363 2.04829 13.4938 2.14838C13.5176 2.18961 13.5413 2.23093 13.565 2.2724C13.6639 2.4455 13.7609 2.62072 13.8449 2.80091L13.848 2.80747L13.8491 2.81462C13.86 2.88671 13.8337 2.94814 13.7897 2.99293C13.7467 3.0367 13.687 3.06492 13.626 3.07695C13.5092 3.10001 13.3574 3.06577 13.3094 2.92226C13.2147 2.75237 13.119 2.58255 13.0232 2.41262C12.8671 2.13559 12.7109 1.85825 12.5583 1.57978L12.5579 1.57999L12.5556 1.57385C12.539 1.53125 12.5389 1.48813 12.5441 1.45064Z" fill="#161616" stroke="#161616" stroke-width="0.1"></path>
</svg>`,

    remoteSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 18 18" fill="none">
  <path d="M8.99939 0.000331702C8.83827 -0.0065736 8.70671 0.0954065 8.60209 0.206259C5.81165 2.88128 3.01987 5.55495 0.230264 8.23081C-0.0291998 8.49912 -0.0792651 8.94541 0.130699 9.25742C0.29086 9.51772 0.600391 9.66439 0.9029 9.64401C1.36128 9.64401 1.81967 9.64401 2.27805 9.64401C2.27865 12.0395 2.27686 14.4351 2.27894 16.8306C2.29093 17.3744 2.71445 17.8719 3.24838 17.9734C3.46999 18.0154 3.69659 17.9921 3.92072 17.9982C4.7985 17.9977 5.67631 17.9991 6.55408 17.9975C6.80297 17.9897 7.00936 17.7523 6.98576 17.5051C6.98602 15.867 6.98524 14.229 6.98615 12.591C6.9893 12.4136 7.16486 12.2798 7.33625 12.3022C8.46555 12.3024 9.59485 12.3016 10.7241 12.3025C10.902 12.3057 11.0344 12.4815 11.013 12.6526C11.0134 14.2906 11.0122 15.9286 11.0136 17.5666C11.0201 17.816 11.2592 18.0217 11.5062 17.9982C12.527 17.9972 13.5478 18.0003 14.5685 17.9966C15.1067 17.9775 15.5952 17.5564 15.696 17.028C15.738 16.8064 15.7146 16.5798 15.7207 16.3557C15.7207 14.1184 15.7207 11.8812 15.7207 9.64397C16.2234 9.64225 16.7263 9.64746 17.2288 9.64129C17.6344 9.617 17.9864 9.25926 17.9984 8.85217C18.0167 8.57713 17.8796 8.31231 17.6725 8.13739C14.8806 5.46227 12.0897 2.78607 9.29715 0.111621C9.21557 0.0402153 9.1078 -6.60649e-06 8.99939 0.000331702ZM8.99939 1.08614C11.6592 3.6355 14.319 6.18486 16.9788 8.73423C16.3942 8.73543 15.8096 8.73182 15.2252 8.73604C14.9793 8.75222 14.7868 8.99234 14.8108 9.23498C14.8103 11.759 14.8121 14.283 14.81 16.807C14.8013 16.9809 14.6291 17.1099 14.4604 17.0884C13.6145 17.0884 12.7687 17.0884 11.9229 17.0884C11.9223 15.5789 11.9241 14.0694 11.922 12.5599C11.91 12.0162 11.4866 11.5187 10.9527 11.4171C10.731 11.3751 10.5044 11.3985 10.2803 11.3924C9.26545 11.3932 8.25059 11.3907 7.23581 11.3936C6.70382 11.4092 6.21839 11.8183 6.10718 12.3377C6.05598 12.5667 6.08245 12.8023 6.07587 13.0348C6.07587 14.386 6.07587 15.7372 6.07587 17.0884C5.2045 17.0874 4.333 17.0905 3.46172 17.0868C3.2871 17.0732 3.16684 16.8979 3.18794 16.7303C3.18755 14.2088 3.18874 11.6873 3.18735 9.16579C3.18091 8.91643 2.94174 8.71075 2.69477 8.73423C2.13652 8.73423 1.57827 8.73423 1.02002 8.73423C3.67981 6.18486 6.3396 3.6355 8.99939 1.08614Z" fill="#161616"></path>
</svg>`,
    onsiteSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 18 18" fill="none">
  <path d="M4.98815 17.0525H7.40184V13.9701C7.40184 13.7087 7.6035 13.4965 7.85212 13.4965H10.1481C10.3967 13.4965 10.5982 13.7087 10.5982 13.9701V17.0525H13.0119V4.59933V0.947464H4.98815V4.59933V17.0525ZM5.94583 9.77612H7.33216V11.235H5.94583V9.77612ZM10.6678 9.77612H12.0542V11.235H10.6678V9.77612ZM8.30694 9.77612H9.69327V11.235H8.30694V9.77612ZM5.94583 6.26588H7.33216V7.72476H5.94583V6.26588ZM10.6678 6.26588H12.0542V7.72476H10.6678V6.26588ZM8.30694 6.26588H9.69327V7.72476H8.30694V6.26588ZM5.94583 2.75541H7.33216V4.21429H5.94583V2.75541ZM10.6678 2.75541H12.0542V4.21429H10.6678V2.75541ZM8.30694 2.75541H9.69327V4.21429H8.30694V2.75541ZM0.444006 18C-0.148002 18 -0.148002 17.0525 0.444006 17.0525H0.795187V5.94687C0.795187 5.73192 0.931288 5.55044 1.11759 5.49238L4.0878 4.27691V0.473846C4.0878 0.212217 4.28925 0 4.53787 0H13.4621C13.7108 0 13.9122 0.212217 13.9122 0.473846V4.27691L16.8824 5.49238C17.0687 5.55044 17.2048 5.73192 17.2048 5.94687V17.0525H17.556C18.148 17.0525 18.148 18 17.556 18C11.8521 18 6.14793 18 0.444006 18ZM8.30218 17.0525H9.69782V14.444H8.30218V17.0525ZM16.3045 6.26907L13.9122 5.29018V17.0525H16.3045V6.26907ZM4.0878 5.29018L1.69553 6.26907V17.0525H4.0878V5.29018Z" fill="#161616"/>
</svg>`,
    fulltimeSvg: `<?xml version="1.0"?>
<svg xmlns="http://www.w3.org/2000/svg" id="line" viewBox="0 0 64 64"><path d="M29.34082,57.86523a26.0101,26.0101,0,1,1,25.43457-13.331,1.00059,1.00059,0,0,0,1.75.9707A27.99782,27.99782,0,1,0,29.13965,59.85547c.03418.00293.06836.00488.10156.00488a1.00009,1.00009,0,0,0,.09961-1.99512Z"/><path d="M36,32a3.99552,3.99552,0,0,0-3-3.858V12a1,1,0,0,0-2,0V28.142A3.99326,3.99326,0,0,0,28.142,31H17a1,1,0,0,0,0,2H28.142A3.99158,3.99158,0,0,0,36,32Zm-4,2a2,2,0,1,1,2-2A2.0026,2.0026,0,0,1,32,34Z"/><path d="M55.43262,48.10254l-5.30506-1.76917c6.52381-4.02148,3.66254-14.33709-4.10919-14.33331-7.77386.002-10.63544,10.30628-4.10858,14.3338l-5.30627,1.76868a6.67111,6.67111,0,0,0-4.56739,6.33691V57.377A2.6261,2.6261,0,0,0,34.65918,60H57.377A2.6261,2.6261,0,0,0,60,57.377v-2.9375A6.67112,6.67112,0,0,0,55.43262,48.10254ZM40.25684,39.76172c.24243-7.614,11.28155-7.6131,11.52246.00012C51.5376,47.37537,40.49774,47.37268,40.25684,39.76172ZM58,57.377a.6235.6235,0,0,1-.623.623H34.65918a.6235.6235,0,0,1-.623-.623v-2.9375a4.67553,4.67553,0,0,1,3.2002-4.44043l6.14941-2.04882a8.37792,8.37792,0,0,1,5.26465-.001L54.7998,49.999A4.67552,4.67552,0,0,1,58,54.43945Z"/></svg>
`,
  }),
  methods: {
    ...mapActions([
      'retrieveEmployersDropdown',
      'retrieveReviewJobs',
      'approveReviewJob',
      'rejectReviewJob',
      'retrieveFreelancerDocumentPreviewAdmin',
    ]),

    setJobForCheck(id, status) {
      this.check.status = status;
      this.check.jobId = id;
    },

    checkJob(jobId, status) {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/job/check`,
          {
            mm_job_id: jobId,
            check: status,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.$refs.closeUser.click();
          this.check.id = '';
          this.check.status = true;
          this.handleSearchFilters();
        });
    },
    doSearch(searchedText) {
      this.searchText = searchedText;
      this.currentPage = 1;
      this.handleSearchFilters();
    },

    getWorkPlace(workplace) {
      if (workplace === 1) {
        return this.onsiteSvg;
      } else if (workplace === 2) {
        return this.hybridSvg;
      } else {
        return this.remoteSvg;
      }
    },

    getWorkPlacePopper(workplace) {
      if (workplace === 1) {
        return 'Onsite';
      } else if (workplace === 2) {
        return `Hybrid`;
      } else {
        return `Remote`;
      }
    },

    handleSearch() {
      this.isLoading = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/job/list`,
          {
            search_word: this.searchText,
            page: this.currentPage,
            count: this.pageCount,
            include_previously_checked_jobs: this.isPreviouslySubmited,
            country: this.selectedCountry,
            mm_employers_ids: this.selectedEmployers,
            contacts_filter: this.contactFilter,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.employers = res.data.data;
          this.totalPages = res.data.last_page;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    handleSearchFilters() {
      this.isLoading = true;
      this.currentPage = 1;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/job/list`,
          {
            search_word: this.searchText,
            page: this.currentPage,
            count: this.pageCount,
            include_previously_checked_jobs: this.isPreviouslySubmited,
            country: this.selectedCountry,
            mm_employers_ids: this.selectedEmployers,
            contacts_filter: this.contactFilter,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.employers = res.data.data;
          this.totalPages = res.data.last_page;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    getAllEmployers() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/marketing/employers/dropdown`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
        })
        .then(res => {
          this.employersDropdown = Object.entries(res.data).map(([id, name]) => ({ id, name }));
        })
        .catch(err => {
          console.log(err);
        });
    },

    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        // this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        // this.previousPage();
      }
    },
    nextPage() {
      if (this.currentPage >= 1) {
        this.isLoading = true;
        this.currentPage++;
        this.handleSearch();
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.isLoading = true;
        --this.currentPage;

        this.handleSearch();
      } else {
        this.currentPage = 1;
      }
    },
    setPageByNumber(pageNumber) {
      if (pageNumber > this.totalPages || pageNumber < 1) return;
      this.isLoading = true;
      this.currentPage = pageNumber;

      this.handleSearch();
    },
    setToFirstPage() {
      this.isLoading = true;
      this.currentPage = 1;

      this.handleSearch();
    },
    setToLastPage(lastPage) {
      this.isLoading = true;
      this.currentPage = lastPage;

      this.handleSearch();
    },

    getActualCountry() {},
  },
  computed: {
    ...mapGetters([
      'getEmployersDropdown',
      'getUserProfile',
      'getCurrentPage',
      'getTotalPages',
      'getAllCountries',
    ]),
  },
  mounted() {
    this.isLoading = true;
    this.handleSearchFilters();
    this.getAllEmployers();
    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.table-controls {
  // min-height: 50vh;
}

.svg-icon {
  cursor: pointer;
  width: 25px !important;
  height: 25px !important;
}

.checked {
  color: #ff741e !important;
}

.icons {
  display: flex;
  align-items: center;
  gap: 12px;
  div {
  }
}

.modal-body {
  p {
    margin-bottom: 0;
  }
}

.fa-briefcase {
  font-size: 18px;
}

.icon-wrapper {
  .svg-icon {
    width: 18px;
    height: 18px;
  }

  /*  a {
    fill: #28a745;

    &:hover {
      fill: #1e8035;
    }
  } */

  /* a:not(:first-child) {
    fill: #f02800;

    &:hover {
      fill: #b61e00;
    }
  } */
}

.mobile-only {
  display: none;
}

.desktop-only {
  display: block;
}

.desktop-only-table {
  display: table;
  table-layout: auto;
}

.controls-wrap {
  width: 100%;
  .integration-group {
    width: 39.3%;
  }
}

.card {
  height: 81.7vh;
}

@media only screen and (max-width: 1251px) {
  .card {
    margin: 24px 23px 0 23px !important;
  }
}

@media only screen and (max-width: 992px) {
  .card {
    min-height: 100vh;
    margin: 24px 0px 0 0px !important;
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  .card {
    min-height: 100vh;
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}

@media only screen and (max-width: 576px) {
  #wrapper {
    .card {
      min-height: 100vh !important;
      margin-top: 0 !important;
    }
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}
</style>
